import { useEffect } from 'react';
/**
 * NavigationBlock component that prevents accidental navigation away from a page
 * with unsaved changes.
 *
 * Currently only blocks browser navigation (refresh, close tab) using beforeunload.
 * In-app navigation blocking requires data router (createBrowserRouter) which is
 * not yet implemented - see https://reactrouter.com/en/main/hooks/use-blocker
 */
const NavigationBlock = ({ message }) => {
    // Handle browser beforeunload (refresh, close tab, external navigation)
    useEffect(() => {
        const alertUser = (e) => {
            e.preventDefault();
            e.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', alertUser);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
        };
    }, [message]);
    return null;
};
export default NavigationBlock;
